import React, { useEffect, useState } from 'react';
import HeaderFFF from '../../../components/HeaderFFF'
import Header from '../../../components/Header'
import Footer from "../../../components/Footer";
import { Link } from 'react-router-dom';
import '../../../styles/injury.css'

export default function CatastrophicInjuries() {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1000);
    
        useEffect(() => {
            const handleResize = () => {
                setIsMobile(window.innerWidth <= 991);
            };
    
            window.addEventListener('resize', handleResize);
            return () => window.removeEventListener('resize', handleResize);
        }, []);
    
        return(
            <>
            {isMobile ? <Header /> : <HeaderFFF />}
        <div id="injury">
            <div id="fields-header-container">
                <svg xmlns="http://www.w3.org/2000/svg" width="102" height="2" viewBox="0 0 102 2" fill="none">
                    <path d="M101 1H1" stroke="#BF9874" stroke-width="2" stroke-linecap="round"/>
                </svg>
                <h2>Catastrophic Injuries</h2>
                <svg xmlns="http://www.w3.org/2000/svg" width="102" height="2" viewBox="0 0 102 2" fill="none">
                    <path d="M101 1H1" stroke="#BF9874" stroke-width="2" stroke-linecap="round"/>
                </svg>
            </div>
            <div className="pi-go-back">
                        <Link to="/fields-of-expertise/personal-injury">Take me back</Link>
                </div>
            <div className="pi-text">
                <p>After suffering from a severe brain, spinal cord, or other <b>disabling injury</b>—which are known
as <b>catastrophic injuries</b>—you can expect to be dealing with it for the rest of your life.<br/><br/>
It is not just the immediate medical costs that you will have to worry about with a catastrophic
injury. In many catastrophic injury cases, you will suffer from an extended loss of income and
may be unable to resume work. Plus, some medical costs can also be lifelong. Your family and
social life may be impacted, not to mention the pain and suffering that you will experience,
which will detract from the quality of your life.<br/><br/>
<span className="pi-sub-section">Common Types of Catastrophic Injury Cases We Handle</span><br/><br/>
If you have suffered any of the following catastrophic personal injuries, our Toronto catastrophic
personal injury lawyers are more than prepared to help you file your catastrophic injury claims:
<ul>
<li> Traumatic Brain Injury Cases </li>
<li> Spinal, Back and Vertebrae Injury Cases</li>
<li> Paralysis and Quadriplegic Injury Cases</li>
<li> Amputation and Disfigurement Injury Cases</li>
<li> Burns and Scar Injury Cases</li>
<li> Fracture or Broken Bone Injury Cases</li>
<li> Injury to Children and Infants</li>
<li> Wrongful Death and Fatal Accident Cases</li>
</ul>
<span className="pi-sub-section">Catastrophic Injury Compensation</span><br/><br/>
After suffering a catastrophic injury, it’s important to receive the benefits that will be necessary
for you to recover and deal with the ongoing complications from your accident. Unfortunately,
the Ontario provincial government has made cuts that favour insurance providers and limit the
amount of benefits you may receive.<br/><br/>

To receive benefits after a catastrophic injury, it’s crucial that you have an experienced personal
injury lawyer who can fight for the compensation you need. CLV has a track record of securing
the maximum amount of benefits that our clients can receive.<br/><br/>
<span className="pi-sub-section">Call the Catastrophic Injury Lawyers at CLV</span><br/><br/>
A <b>catastrophic injury</b> will change your life. However, receiving the compensation to which you
are entitled will help you manage and cope with your personal injury. If you have suffered a
catastrophic injury, let the <b>personal injury lawyers</b> team at CLV in Greater Toronto Area,
Etobicoke and Vaughan, Ontario help you get the accident benefits that you need. We are
equipped to handle complex legal and insurance issues arising from your accident.
To arrange a Free consultation, <Link to="/contact-us">contact us</Link> today.</p>
            </div>
            <div className="pi-go-back">
                        <Link to="/fields-of-expertise/personal-injury">Take me back</Link>
                </div>
        </div>
            <Footer />
        </>
        );
}